"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addWebClientIdToURL = void 0;
const addWebClientIdToURL = (url, webClientId) => {
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.set("web_client_id", webClientId);
    return parsedUrl.toString();
};
exports.addWebClientIdToURL = addWebClientIdToURL;
//# sourceMappingURL=web-client-id-utils.js.map